import React, { useState, useEffect } from 'react';
//import { ChartCards } from "../dashboard/charts/ChartCards";
import { Header } from "../dashboard/Header";
import { SummaryCards } from "../dashboard/SummaryCards";
//import { BestProducts } from "../dashboard/products/BestProducts";
//import { TopSellers } from "../dashboard/products/TopSellers";
import { SourceChart } from "../dashboard/charts/SourceChart";
import { Orders } from "../dashboard/Orders";
//import { RiArrowDropDownLine } from "react-icons/ri";

const months1 = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 }
];

function getDynamicMonths(currentDate) {
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-indexed (0 = January, 11 = December)
  
  const months = [];
  
  // Start from the month after the current month in the current year
  for (let year = currentYear - 1; year <= currentYear; year++) {
    for (let month = 0; month < 12; month++) {
      // Only include months from the previous year starting from April
      if (year === currentYear - 1 && month < 3) continue; // Skip Jan, Feb, Mar of the previous year
      // Only include months up to the current month in the current year
      if (year === currentYear && month > currentMonth) continue; // Skip future months in the current year
      // Format month to be two digits
      const formattedMonth = (month + 1).toString().padStart(2, '0'); // month + 1 to convert from 0-indexed to 1-indexed
      months.push({
        label: `${year}-${new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(year, month))}`,
        value: `${year}-${formattedMonth}` // month + 1 to convert from 0-indexed to 1-indexed
      });
    }
  }
  
  return months;
}

// Example usage
const currentDate = new Date();
const months = getDynamicMonths(currentDate);
export function Default() {
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Get current month and format it
  const [selectedMonth, setSelectedMonth] = useState(`${currentYear}-${currentMonth}`); // Set default to current month

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };
  return (
    <div className="p-4 space-y-4">
      <div style={{ fontFamily: 'Poppins,sans-serif' }}>
        <Header />
        <SummaryCards />
        {/* <ChartCards />
        <div className="xl:flex block w-full px-[4px] gap-5">
          <BestProducts />
          <TopSellers />
        </div>  */}
        <div className="xl:flex block w-full px-[4px] gap-5">
          <div className="bg-white shadow-md rounded-lg mt-4 xl:w-[40%] w-full">
            <div className="flex justify-between p-4 border-b mt-1">
              <p className="text-[16px] font-medium text-[#495057] leading-[19.2px]">Components</p>
              <span className='flex text-[13px] leading-[19.5px] ml-[2px] text-[#878A99]'>
                <select className='text-[13px] leading-[19.5px] ml-[2px] text-[#878A99] border border-[#CED4DA] rounded p-1'
                value={selectedMonth}
                onChange={handleMonthChange}
                >
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="flex justify-center">
              <div className="w-full md:w-[60%] xl:w-full">
                <SourceChart month={selectedMonth}/>
              </div>
            </div>
          </div>
          <div className="bg-white shadow-md rounded-lg mt-4 xl:w-[60%] w-full">
            <div className="flex justify-between p-4 border-b">
              <p className="text-[16px] mt-1 font-medium text-[#495057] leading-[19.2px]">Component Status</p>
              <p className='text-[13px] mt-1 leading-[19.5px] text-[#878A99]'></p>
            </div>
            <Orders />
          </div>
        </div>
      </div>
    </div>
  )
}
